var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconActionRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.196,
    viewBox: "0 0 24 23.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 22.782a.767.767 0 0 1 .408-1.478A9.97 9.97 0 0 0 19.706 5.796l-.455 2.58a.767.767 0 1 1-1.51-.266l.636-3.607a1.19 1.19 0 0 1 .5-.778l.011-.01a.766.766 0 0 1 .685-.2 1.175 1.175 0 0 1 .185.018l3.607.636a.767.767 0 1 1-.266 1.51l-1.829-.322A11.506 11.506 0 0 1 8.6 22.782zm-8.487-9.68A11.509 11.509 0 0 1 13.336.146a.767.767 0 1 1-.244 1.514 9.97 9.97 0 0 0-8.834 16.689v-2.56a.767.767 0 0 1 1.533 0v3.662A1.193 1.193 0 0 1 4.6 20.644H.936a.767.767 0 0 1 0-1.533h1.941a11.452 11.452 0 0 1-2.764-6.009z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionRefresh);
export default __webpack_public_path__ + "static/media/icon-action-refresh.326e5c82.svg";
export { ForwardRef as ReactComponent };